import { type z } from 'zod';

import {
  type INSERT_PRINTER_SCHEMA,
  type UPSERT_PRINT_PREFERENCES_SCHEMA,
  type UPSERT_WORKSTATION_SCHEMA,
  type WORKSTATION_PRINT_PREFERENCES_SCHEMA,
  type WORKSTATION_SCHEMA,
  type WORKSTATIONS_LIST_SCHEMA,
} from '../schemata/workstation.schema';

export type PrinterInfo = {
  canAttemptPrint?: boolean;
  connection: PrinterConnection | null;
  density: null | number;
  driver: null | string;
  isSynced: boolean;
  status: 'offline' | 'online' | 'unknown';
  supportedSizes: string[];
};

export enum PrinterConnection {
  Bluetooth = 'BLUETOOTH',
  Network = 'NETWORK',
  Unknown = 'UNKNOWN',
  Usb = 'USB',
}

export enum PrintColor {
  BlackAndWhite = 'bw',
  Color = 'color',
}

export enum PrintInitiation {
  ClickToPrint = 'CLICK_TO_PRINT',
  DownloadPdf = 'DOWNLOAD_PDF',
  ScanToPrint = 'SCAN_TO_PRINT',
}

export enum PrintAssetType {
  Manifest = 'MANIFEST',
  PickList = 'PICK_LIST',
  ShippingLabel = 'SHIPPING_LABEL',
}

export type Workstation = z.TypeOf<typeof WORKSTATION_SCHEMA>;
export type WorkstationsList = z.TypeOf<typeof WORKSTATIONS_LIST_SCHEMA>;
export type InsertPrinters = z.TypeOf<typeof INSERT_PRINTER_SCHEMA>;
export type UpsertRemotePrintPreferences = z.TypeOf<typeof UPSERT_PRINT_PREFERENCES_SCHEMA>;
export type UpsertWorkstation = z.TypeOf<typeof UPSERT_WORKSTATION_SCHEMA>;
export type RemotePrintPreferences = z.TypeOf<typeof WORKSTATION_PRINT_PREFERENCES_SCHEMA>;
